import { c as _c } from "react/compiler-runtime";
export function StringList(t0) {
  const $ = _c(11);
  const {
    data,
    info,
    fallback,
    className
  } = t0;
  if (!data?.length) {
    let t1;
    if ($[0] !== className || $[1] !== fallback) {
      t1 = <div className={className}>{fallback}</div>;
      $[0] = className;
      $[1] = fallback;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  let t1;
  if ($[3] !== data || $[4] !== info) {
    let t2;
    if ($[6] !== info) {
      t2 = d => <div key={d}>{info?.find(i => i.code === d)?.name || d}</div>;
      $[6] = info;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    t1 = data.map(t2);
    $[3] = data;
    $[4] = info;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[8] !== className || $[9] !== t1) {
    t2 = <div className={className}>{t1}</div>;
    $[8] = className;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
}